import styled from '@emotion/styled';
import { colors } from '~/styles/constants';

interface SpinnerSvgProps {
  size?: number;
}

const SpinnerSvg = styled('svg')<SpinnerSvgProps>`
  height: ${(props) => `${props.size}px`};
  vertical-align: middle;

  & > path {
    fill: black;
  }

  animation: spin 600ms infinite;

  @keyframes spin {
    0% {
      transform: rotate(0deg) translateZ(0px);
    }
    100% {
      transform: rotate(360deg) translateZ(0px);
    }
  }
`;

interface SpinnerProps {
  className?: string;
  size?: number;
}

const Spinner = (props: SpinnerProps) => {
  return (
    <SpinnerSvg
      viewBox="0 0 50 50"
      className={`${props.className || ''} spinner`}
      size={props.size}
    >
      <path d="M43.935,25.145c0-10.318-8.364-18.683-18.683-18.683c-10.318,0-18.683,8.365-18.683,18.683h4.068c0-8.071,6.543-14.615,14.615-14.615c8.072,0,14.615,6.543,14.615,14.615H43.935z" />
    </SpinnerSvg>
  );
};

Spinner.defaultProps = {
  size: 30,
};

export const GreenSpinner = styled(Spinner)`
  & > path {
    fill: ${colors.primary};
  }
`;

export const WhiteSpinner = styled(Spinner)`
  & > path {
    fill: white;
  }
`;

export const DarkBlueSpinner = styled(Spinner)`
  & path {
    fill: ${colors.sea700};
  }
`;

export default Spinner;
